import React, { useState, useEffect} from "react";
import {
  Typography,
  Button,
  TextField,
  FormControl,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { loginuser } from "../../actions/loginActions";
import { useStateValue } from "../../context/store";
import Alert from "@material-ui/lab/Alert";
import ModalConfirm from '../../utils/form/modalConfirmBase';
import InputAdornment from "@material-ui/core/InputAdornment";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Visibility from "@material-ui/icons/Visibility";
import FormHelperText from "@material-ui/core/FormHelperText";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import LoginContainer from "./LoginContainer";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { styles } from "./styles";

const Login = (props) => {
  const classes = styles();

  const [{ openSnackbar }, dispatch] = useStateValue();
  const [validEmail, setValidEmail] = useState(true);
  const [loading, setLoading] = useState(false);
  const [validPassword, setValidPassword] = useState(true);
  const [invalidLogin, setInvalidLogin] = useState(false);
  const [usuario, setUsuario] = useState({
    username: "",
    password: "",
    showPassword: false,
  });
  const [message, setMessage] = useState({
    description : '',
    textButtonSubmit : '',
    handleClick : () => {} ,
    handleClickOut : () => {},
    title: '',
    oneButtons : false,
    type : '',
    open : false
})

  const handleClickShowPassword = () => {
    setUsuario({ ...usuario, showPassword: !usuario.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  let validateEmail = (email) => {
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegex.test(email)) {
      setValidEmail(false);
    } else {
      setValidEmail(true);
    }
  };

  let validatePassword = (password) => {
    //let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])([A-Za-z\d$@$!%*?&]|[^ ]){8,15}$/;
    let passwordRegex = /^(?!\s*$).+/;
    if (passwordRegex.test(password)) {
      setValidPassword(false);
    } else {
      setValidPassword(true);
    }
  };

  const addValuesToMemory = (e) => {
    const { name, value } = e.target;
    if (!value.includes(" ")) {
      if (name === "username") {
        validateEmail(value);
      }
      if (name === "password") {
        validatePassword(value);
      }
      setUsuario({
        ...usuario,
        [name]: value,
      });
    }
  };

  const schema = yup.object().shape({
    username: yup
      .string()
      .nullable()
      .required("El correo electrónico es obligatorio")
      .matches(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Ingrese un correo electrónico válido"
      ),
    password: yup.string().required("La contraseña es obligatoria"),
  });

  const { register, errors } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  const handleClickCloseModal = () => {
    setMessage({...props.message, open: false}); 

  }

  const  resetPassword= (body) => {
    const {token, email} = body;
   setLoading(false);
   handleClickCloseModal();
   props.history.push(`/auth/reset/?username=${email}&token=${token}`);
  };

  const propsMessage = props.match.params.message;

  useEffect(() => {
    const messageModal = () => {
      if(propsMessage){
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: "Su sesión ha expirado, ingrese de nuevo",
            severity: "success",
          },
      })
      }
    }
    messageModal();
   
  }, [dispatch, propsMessage])

  const loginUserBtn = (e) => {
    e.preventDefault();
    setLoading(true);
    loginuser(usuario, dispatch).then(
      (response) => {
       
        if (response.status === 200 || response.code === 200) {
          window.localStorage.setItem(
            "token_app",
            response.data != null && response.data.access_token
          );
          setInvalidLogin(false); 
          const temporaly = JSON.parse(localStorage.getItem("state"))
          const body = {
            token: temporaly?.token?.access_token,
            email: temporaly?.userInfo?.username
          }
          
          if(temporaly?.userInfo?.passwordTemporary){
              resetPassword(body)
             
            } else {
              setTimeout(() =>  {
                dispatch({
                  type: "SET_BREADCRUMB",
                  breadCrumbText: 'Inicio',
                  index: -10,
                });
                props.history.push("/dashboard/home")
              }, 2000);
            }
          
        } else {
          setInvalidLogin(true);
        }
      },
      (error) => {
        setLoading(false);
        if (error.error_description !== undefined) {
          dispatch({
            type: "OPEN_SNACKBAR",
            openMessage: {
              open: true,
              message: error.error_description,
            },
          });
        } else if (error.data?.length > 0 && error.status === 404) {
          dispatch({
            type: "OPEN_SNACKBAR",
            openMessage: {
              open: true,
              message: error?.data?.detail,
            },
          });
        } else if (error.status === 500) {
          dispatch({
            type: "OPEN_SNACKBAR",
            openMessage: {
              open: true,
              message: error?.data?.detail,
            },
          });
        } else {
          dispatch({
            type: "OPEN_SNACKBAR",
            openMessage: {
              open: true,
              message: error?.data?.detail,
            },
          });
          setLoading(false);
        }
      }
    );
  };

  const showPasswordIcon = () => {
    if (usuario.showPassword) {
      return (
        <Visibility
          className={classes.cursorPointer}
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
          edge="end"
        ></Visibility>
      );
    } else {
      return (
        <VisibilityOff
          className={classes.cursorPointer}
          aria-label="toggle password VisibilityOff"
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
          edge="end"
        ></VisibilityOff>
      );
    }
  };

  const LoginComponent = () => (
    <div spacing={0} className={classes.container}>
      <div style={{ width: "100%" }}>
        <div className={classes.paper} >
          <Typography className={classes.titleOne}>
            <b>IDENTIFÍQUESE</b>
          </Typography>
          <form>
            <Grid container>
              <Grid item xs={12} md={12} lg={12}>
                <FormControl className={classes.formControl}>
                  <TextField
                    inputRef={register}
                    onChange={addValuesToMemory}
                    variant="outlined"
                    label="Correo electrónico"
                    name="username"
                    margin="normal"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                    error={
                      errors.hasOwnProperty("username") &&
                      errors["username"].message
                    }
                    helperText={
                      errors.hasOwnProperty("username") &&
                      errors["username"].message
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <FormControl className={classes.formControl} variant="outlined">
                  <InputLabel
                    htmlFor="outlined-adornment-password"
                    error={
                      errors.hasOwnProperty("password") &&
                      errors["password"].message
                    }
                    className={classes.mt10}
                  >
                    Contraseña
                  </InputLabel>
                  <OutlinedInput
                    error={
                      errors.hasOwnProperty("password") &&
                      errors["password"].message
                    }
                    type={usuario.showPassword ? "text" : "password"}
                    onChange={addValuesToMemory}
                    className={classes.mt10}
                    inputRef={register}
                    variant="outlined"
                    label="Contraseña"
                    name="password"
                    startAdornment={
                      <InputAdornment position="start">
                        {showPasswordIcon()}
                      </InputAdornment>
                    }
                  />
                  <FormHelperText style={{ color: "#f44336" }}>
                    {errors.hasOwnProperty("password") &&
                      errors["password"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid
                container
                spacing={2}
                justify="center"
                style={{ marginTop: "5%" }}
              >
                <Grid item xs={12} md={12} lg={6}>
                  <Button
                    disabled={validEmail || validPassword}
                    className={classes.submit}
                    onClick={loginUserBtn}
                    variant="contained"
                    disableElevation
                    type="submit"
                    fullWidth
                  >
                    {loading ? (
                      <CircularProgress style={{ width: 25, height: 25 }} />
                    ) : 'INGRESAR'}
                  </Button>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    className={classes.submit}
                    onClick={() => props.history.push("/auth/registrar")}
                    disableElevation
                  >
                    Regístrese
                  </Button>
                </Grid>
                <div className={classes.regetPassword}>
                  <a href
                    onClick={() => props.history.push("/auth/validate")}
                    className={classes.forgot}
                  >
                    Olvidé mi clave
                  </a>
                </div>
              </Grid>
              {invalidLogin ? (
                <Alert style={{ marginTop: "20px" }} severity="warning">
                  Su usuario o contraseña son incorrectos, por favor verifique.
                </Alert>
              ) : (
                ""
              )}
            </Grid>
            <ModalConfirm 
            description = { message.description }
            textButtonSubmit = { message.textButtonSubmit }
            handleClick = { message.handleClick }
            handleClickOut = { message.handleClickOut }
            oneButtons = { message.oneButtons }
            title = { message.title}
            type = { message.type }
            open = { message.open }
          />
          </form>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <LoginContainer>{LoginComponent()}</LoginContainer>
    </>
  );
};

export default withRouter(Login);
